var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 9H17.7296C12.2696 9 9.01465 12.255 9.01465 17.715V30.27C9.01465 35.73 12.2696 38.985 17.7296 38.985H30.2846C35.7446 38.985 38.9996 35.73 38.9996 30.27V17.715C38.9996 12.255 35.7446 9 30.2846 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.285 31.1702H20.52C22.155 31.1702 23.43 29.8952 23.43 28.2602V26.0251C23.43 24.3901 22.155 23.1151 20.52 23.1151H17.655C17.775 20.4001 18.405 19.9951 20.22 18.9301C20.76 18.6151 20.925 17.9252 20.61 17.3852C20.4 17.0252 20.025 16.8301 19.635 16.8301C19.44 16.8301 19.245 16.8751 19.065 16.9801C16.38 18.5701 15.375 19.6052 15.375 24.2252V28.2301C15.375 29.8651 16.68 31.1702 18.285 31.1702Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4803 31.1702H29.7153C31.3503 31.1702 32.6253 29.8952 32.6253 28.2602V26.0251C32.6253 24.3901 31.3503 23.1151 29.7153 23.1151H26.8503C26.9703 20.4001 27.6003 19.9951 29.4153 18.9301C29.9553 18.6151 30.1203 17.9252 29.8053 17.3852C29.5953 17.0252 29.2203 16.8301 28.8303 16.8301C28.6353 16.8301 28.4403 16.8751 28.2603 16.9801C25.5753 18.5701 24.5703 19.6052 24.5703 24.2252V28.2301C24.5853 29.8651 25.8903 31.1702 27.4803 31.1702Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteDown);
export default __webpack_public_path__ + "static/media/quoteDown.b71a457ea1b013d02a25d866933448cc.svg";
export { ForwardRef as ReactComponent };